import React from 'react';

import ClientDomainStore from '../../stores/ClientDomainStore';
import DomainActions from "../../actions/DomainActions";

function getState() {
    return {
        hasDomains: ClientDomainStore.get().length > 0,
        loading: ClientDomainStore.loading(),
    };
}

const DomainHint = React.createClass({
    getInitialState: function () {
        return getState();
    },
    componentDidMount: function() {
        ClientDomainStore.addChangeListener(this._onChange);
    },
    componentWillMount: function () {
        if (!ClientDomainStore.has() && !ClientDomainStore.loading()) {
            DomainActions.getDomains();
        }
    },
    componentWillUnmount: function () {
        ClientDomainStore.removeChangeListener(this._onChange);
    },
    render: function () {
        if (!this.state.hasDomains) {
            return <div></div>;
        }

        return this.props.children;
    },
    _onChange: function() {
        this.setState(getState());
    }
});

module.exports = DomainHint;



// WEBPACK FOOTER //
// ./app/components/Domain/DomainHint.js